import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "xl:flex align-items-stretch gutter-s3" }
const _hoisted_3 = { class: "sm:flex align-items-center justify-content-between gutter-y-s3 mt-s0" }
const _hoisted_4 = { class: "flex flex-wrap text-sm gutter-x-s6 gutter-y-s3 align-items-center" }
const _hoisted_5 = { class: "w-12 text-sm text-right sm:w-auto" }
const _hoisted_6 = {
  class: "toggleable-content",
  role: "region"
}
const _hoisted_7 = { class: "panel-content" }
const _hoisted_8 = { class: "flex pt-s3 flex-column gutter-y-s3" }

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import PortfolioTokenList from './portfolioToken/PortfolioTokenList.vue';
import Switch from '@/components/switch/Switch.vue';
import ExternalLink from '@/components/ExternalLink.vue';
import PortfolioRingChart from '@/views/pages/liquidity/portfolios/portfolio/portfolioCompound/PortfolioRingChart.vue';
import PortfolioActions from '@/views/pages/liquidity/portfolios/portfolio/portfolioCompound/PortfolioActions.vue';
import { ANALYTIC_FRONTEND_URL, SELECTED_NETWORK_NAME } from '@/helpers/networkParams.helper';
import { NETWORK_SUPPORTS_FARMS } from '@/helpers/supporting-features-in-network';
import { Portfolio } from '@/sdk/entities/portfolio';
import { PortfolioSource } from '@/sdk/entities/PortfolioSource';
import { isAnalyticNetworkSupported } from '@/helpers/analytic.helper';
import { getScanLink } from '@/sdk/utils';
import { canUseFarmLP } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/composables/useEasyModeForm';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioCompound',
  props: {
    portfolio: null
  },
  emits: ["sendTransaction"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'sendTransaction'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  portfolio: Portfolio;
}





const { t } = useI18n();
const router = useRouter();
const { state } = useStore();

const isShowTokens = ref(false);

const contractUrl = computed(() => getScanLink(props.portfolio.contractAddress, 'address'));
const analyticsUrl = computed(
  () =>
    `${ANALYTIC_FRONTEND_URL}portfolios/${
      props.portfolio.contractAddress
    }?net=${SELECTED_NETWORK_NAME.toUpperCase()}`,
);
const isAnalyticsSupported = computed(
  () =>
    isAnalyticNetworkSupported.value && props.portfolio.type === PortfolioSource.PORTFOLIO_LOCALE,
);
const isFarmSupported = computed(
  () =>
    NETWORK_SUPPORTS_FARMS &&
    props.portfolio.type === PortfolioSource.PORTFOLIO_LOCALE &&
    canUseFarmLP(props.portfolio, state.farming.lp),
);

const goToFarm = () => {
  router.push(`/farming/${props.portfolio.contractAddress}`);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PortfolioRingChart, {
        portfolio: __props.portfolio,
        class: "xl:w-8"
      }, null, 8, ["portfolio"]),
      _createVNode(PortfolioActions, {
        portfolio: __props.portfolio,
        class: "xl:w-4",
        onSendTransaction: _cache[0] || (_cache[0] = ($event: any) => (emits('sendTransaction')))
      }, null, 8, ["portfolio"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ExternalLink, {
            label: _unref(t)('portfolio.links.contract'),
            url: _unref(contractUrl),
            color: "secondary"
          }, null, 8, ["label", "url"]),
          (_unref(isAnalyticsSupported))
            ? (_openBlock(), _createBlock(ExternalLink, {
                key: 0,
                label: _unref(t)('portfolio.links.analytics'),
                url: _unref(analyticsUrl),
                color: "secondary"
              }, null, 8, ["label", "url"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (_unref(isFarmSupported))
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "button-text",
                  onClick: goToFarm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('portfolio.links.goToFarm')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Switch, {
          modelValue: isShowTokens.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShowTokens).value = $event)),
          name: _unref(t)('portfolio.showDetails'),
          "name-pos": "left"
        }, null, 8, ["modelValue", "name"])
      ])
    ]),
    _createVNode(_Transition, { name: "toggleable-content" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Divider, { class: "panel-collapse-divider" }),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(PortfolioTokenList, { portfolio: __props.portfolio }, null, 8, ["portfolio"])
            ])
          ])
        ], 512), [
          [_vShow, isShowTokens.value]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})